export default __webpack_public_path__ + "static/logonew_footer-0937d08b04a2f4653d97b1db8cc83e97.svg";